import { render, staticRenderFns } from "./QrCode.vue?vue&type=template&id=23085af6"
import script from "./QrCode.vue?vue&type=script&lang=js"
export * from "./QrCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports